// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ctWn","label":"styles_label__2nokX"};